import { render, staticRenderFns } from "./Form42.vue?vue&type=template&id=72a4a274&scoped=true"
import script from "./Form42.vue?vue&type=script&lang=ts"
export * from "./Form42.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=72a4a274&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4a274",
  null
  
)

export default component.exports